import * as React from 'react'
import IconButton from '@mui/material/IconButton'
import RefreshIcon from '@mui/icons-material/Refresh'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import DangerousIcon from '@mui/icons-material/Dangerous'
import Grid from '@mui/material/Grid'
import Popover from '@mui/material/Popover'
import { format, isAfter, isBefore, sub } from 'date-fns'
import { useTranslation } from 'react-i18next'

interface IAbortButtonProps {
  onClick: () => void
  validTo: Date
  disabled?: boolean
}

const AbortButton: React.FC<IAbortButtonProps> = ({
  onClick,
  validTo,
  disabled,
}) => {
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)

  let color = 'inherit'
  let hoverText = ''
  let icon: string | React.ReactNode = ''
  const now = new Date()
  if (isAfter(now, sub(validTo, { days: 1 }))) {
    color = '#F5BF25'
    icon = <WarningAmberIcon />
    hoverText = 'userEmailAlmostOver'
  }
  if (isBefore(validTo, now)) {
    color = '#D50001'
    icon = <DangerousIcon />
    hoverText = 'userEmailOver'
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item xs display="flex" justifyContent="center">
        <IconButton
          size="small"
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation()
            onClick()
          }}
        >
          <RefreshIcon />
        </IconButton>
      </Grid>
      <Grid item xs display="flex" justifyContent="center" sx={{ color }}>
        <div
          onMouseEnter={(event) =>
            hoverText && setAnchorEl(event.currentTarget)
          }
          onMouseLeave={() => setAnchorEl(null)}
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '0.8em',
            fontWeight: 'bold',
          }}
        >
          {`${t('validTo')} ${format(validTo, 'yyyy-MM-dd')}`}
        </div>
        {icon}

        <Popover
          sx={{ pointerEvents: 'none' }}
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={() => setAnchorEl(null)}
          disableRestoreFocus
        >
          <div style={{ margin: '10px' }}>{t(hoverText)}</div>
        </Popover>
      </Grid>
    </Grid>
  )
}

export default AbortButton
